<app-spinner-host></app-spinner-host>

<mat-sidenav-container appDynamicAside fullscreen>

    <mat-sidenav class="sidenavLeft" position="start">
        <ng-template appDynamicAsideContent></ng-template>
    </mat-sidenav>

    <mat-sidenav [disableClose]="true" class="sidenavRight" position="end">
        <ng-template appDynamicAsideContent></ng-template>
    </mat-sidenav>

    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>

</mat-sidenav-container>
